// extracted by mini-css-extract-plugin
export default {"logo":"_8SJv4","hide":"_5A2mX","image":"_8f+fy","large":"YQit1"};